import { useFreshChat } from 'hooks';

const FreshChat = ({ children }) => {
  useFreshChat();
  return children;
};

export default FreshChat;
